export default {
	SSO_CLIENT_ID: process.env.VUE_APP_SSO_CLIENT_ID,
	SSO_LOGIN_CALLBACK: process.env.VUE_APP_SSO_LOGIN_CALLBACK,
	SSO_LOGOUT_CALLBACK: process.env.VUE_APP_SSO_LOGOUT_CALLBACK,
	SSO_URL: process.env.VUE_APP_SSO_URL,
	SSO_URL_LOGOUT: process.env.VUE_APP_SSO_URL_LOGOUT,
	STATE_URL_BEFORE_LOGIN: "stateURLBeforeLogin",
	AXIOS_REQUEST_TIMEOUT: process.env.AXIOS_REQUEST_TIMEOUT,
	BASE_SERVICE_URL: process.env.VUE_APP_BASE_SERVICE_URL,
	BASE_SIGN_SERVICE_URL: process.env.VUE_APP_SIGN_SERVICE_URL,
	SIGN_TOKEN_BASE_SERVICE_URL: "http://localhost:14007/",

	STORAGE_KEY: {
		ROLE_CODE: "roleCode",
		DEPT_CODE: "deptCoe",
		USER_DEPT_ROLE_ID: "userDeptRoleId",
		CHO_TIEP_NHAN_DOC_ID: "choTiepNhan.docId",
		OTP_TOKEN: "otpToken",
		TOKEN_DATA: "tokenData"
	},

	HTTP_HEADER_KEY: {
		ROLE_CODE: "RoleCode",
		DEPT_CODE: "DeptCode",
		USER_DEPT_ROLE_ID: "UserDeptRoleId",
		OTP_AUTH_HEADER_STRING: "OtpJwt",
		AUTH_HEADER_STRING: "Authorization"
	},
	MENU_LIST: {
		DASHBBOARD: "Tổng quan",
		VB_DEN: "Văn bản đến",
		THONG_BAO: "Thông báo",
		XEM_THONG_BAO: "Xem thông báo",
		THONG_BAO_NOI_BO: "Thông báo nội bộ",
		THONG_BAO_HE_THONG: "Thông báo hệ thống",
		TIN_TUC: "Tin tức hàng ngày",
		QUAN_LY_TIN_TUC: "Quản lý tin tức",
		THAO_LUAN: "Thảo luận",
		QUAN_LY_THAO_LUAN: "Quản lý thảo luận",
		QL_THONG_BAO: "Quản lý thông báo",
		VB_DEN_CHOTIEPNHAN: "Chờ tiếp nhận",
		VB_DEN_CHOXULY: "Chờ xử lý",
		VB_DEN_CHOXULY_CHUTRI: "Văn bản đến/chờ xử lý/Chủ trì",
		VB_DEN_CHOXULY_PHOIHOP: "Văn bản đến/chờ xử lý/Phối hợp",
		VB_DEN_CHOXULY_NHANDEBIET: "Văn bản đến/chờ xử lý/Nhận để biết",
		VB_DEN_UYQUYEN: "Ủy quyền",
		VB_DEN_DAXULY: "Đã xử lý",
		VB_DEN_DAXULY_CHUTRI: "Văn bản đến/Đã xử lý/Chủ trì",
		VB_DEN_DAXULY_PHOIHOP: "Văn bản đến/Đã xử lý/Phối hợp",
		VB_DEN_DAXULY_NHANDEBIET: "Văn bản đến/Đã xử lý/Nhận để biết",
		VB_DEN_DAXULY_VT: "Đã xử lý (VT)",
		VB_DEN_DATIEPNHAN: "Đã tiếp nhận",
		VB_DEN_TO_TRINH_QUA_HAN: "TTr cần cho ý kiến",
		VB_DI: "Văn bản đi",
		VB_DI_DUTHAO: "Văn bản dự thảo",
		VB_DI_DAPHATHANH: "Đã phát hành",
		VB_DI_CHOBANHANH: "Chờ ban hành",
		VB_DI_DABANHANH: "Đã ban hành",
		VB_DI_DAVAOSO: "Đã vào sổ",
		VB_DI_LUONGVB: "Theo dõi văn bản trình ký",
		VB_DI_DA_XOA: "Văn bản đã xóa",
		QL_SOVANBAN: "Quản lý sổ văn bản",
		QL_SOVANBAN_SODEN: "Sổ đến",
		QL_SOVANBAN_SODI: "Sổ đi",
		QL_SOVANBAN_BOOKSO: "Book số văn bản",
		CONGVIEC: "Công việc",
		CONGVIEC_GIAO: "Công việc tôi giao",
		CONGVIEC_DONVI: "Công việc đơn vị",
		CONGVIEC_DUOCGIAO: "Công việc được giao",
		CONGVIEC_LIENQUAN: "Công việc liên quan",
		CONGVIEC_SCORE: "Đánh giá nhân viên",
		CONGVIEC_SCORE_UPDATE: "Cập nhật đánh giá nhân viên",
		CAUHINH: "Cấu hình",
		CAUHINH_LUONGVANBAN: "Luồng văn bản",
		CAUHINH_QUANTRINGUOIDUNG: "Quản trị người dùng",
		CAUHINH_QUANTRIDONVI: "Quản trị đơn vị",
		CAUHINH_QUANLYUYQUYEN: "Quản lý ủy quyền",
		CAUHINH_QUANLYNGAYLE: "Quản lý ngày lễ",
		CAUHINH_QUANLYDANHMUC: "Quản lý danh mục",
		CAUHINH_QUANLYVAITRO: "Quản lý vai trò",
		CAUHINH_QUANLYPHONGHOP: "Quản lý phòng họp",
		CAUHINH_QUANLYTAIXE: "Quản lý tài xế",
		CAUHINH_QUANLYXE: "Quản lý xe",
		CAUHINH_RANKINGREASON: "Danh mục lý do",
		CAUHINH_DOCUMENTTYPE: "Quản lý loại tài liệu",
		// CAUHINH_DOCUMENTTYPE_V2: "Quản lý loại tài liệu v2",
		CAUHINH_THAOLUAN: "Quản lý nhóm thảo luận",
		CAUHINH_HINHNEN: "Quản lý hình nền",
		LICHSU_THAOTAC: "Lịch sử thao tác",
		HANHCHINH: "Hành chính",
		HANHCHINH_DANGKYPHONGHOP: "Đăng ký phòng họp",
		HANHCHINH_DANGKYPHONGHOPDOTXUAT: "Đăng ký phòng họp đột xuất",
		HANHCHINH_YEUCAUDIEUXE: "Yêu cầu điều xe",
		HANHCHINH_YEUCAUDIEUXEDOTXUAT: "Yêu cầu điều xe đột xuất",
		HANHCHINH_THEODOIKETLUANCHIDAO: "Theo dõi kết luận chỉ đạo",
		HANHCHINH_DANGKYLICHTUAN: "Đăng ký lịch tuần",
		HANHCHINH_VEMAYBAY: "Đặt vé máy bay",
		HANHCHINH_KHACHSAN: "Đặt phòng khách sạn",
		SUA_CHUA_NHO: "Sửa chữa nhỏ",
		HANHCHINH_HOTROYEUCAU: "Hỗ trợ yêu cầu",
		HANHCHINH_VANPHONGPHAM: "Văn phòng phẩm",
		BAOCAO: "Báo cáo",
		BAOCAO_VBTHEOSO: "Báo cáo văn bản theo sổ",
		BAOCAO_VBTHEOTRANGTHAI: "Báo cáo văn bản theo trạng thái",
		BAOCAO_TINHHINHXLVB: "Báo cáo tình hình xử lý văn bản của đơn vị",
		BAOCAO_QLCV_TIENDOHOANTHANHCV: "Báo cáo tiến độ hoàn thành công việc",
		BAOCAO_QLCV_TONGHOPTHANG: "Báo cáo đánh giá tổng hợp tháng",
		BAOCAO_QLCV_RANKING_TONGHOP: "Báo cáo tổng hợp đánh giá nhân viên",
		BAOCAO_QLCV_RANKING_TRUNGBINHTHANG:
			"Báo cáo trung bình tháng đánh giá nhân viên",
		BAOCAO_HC_CHI_DAO_TONG_HOP: "Báo cáo tổng hợp theo dõi chỉ đạo",
		BAOCAO_HC_CHI_DAO_CHI_TIET: "Báo cáo chi tiết theo dõi chỉ đạo",
		THUVIEN: "Thư viện",
		THUVIEN_VANBANMAU: "Văn bản mẫu",

		// phase2
		DANHBA: "Danh bạ",
		TAILIEU: "Tài liệu",
		KHOTAILIEU: "Kho tài liệu",
		TAILIEUCHUNG: "Tài liệu chung",
		TAILIEURIENG: "Tài liệu riêng",
	},

	MENU_LIST_DEFAULT() {
		return {
			NOT_DEPARTMENT: [
				this.MENU_LIST.XEM_THONG_BAO,
				this.MENU_LIST.THONG_BAO_HE_THONG,
				this.MENU_LIST.THONG_BAO_NOI_BO
			],
			LANH_DAO: [
				// Văn bản đến
				this.MENU_LIST.VB_DEN,
				this.MENU_LIST.VB_DEN_DAXULY,
				this.MENU_LIST.VB_DEN_CHOXULY,
				// Văn bản đi
				this.MENU_LIST.VB_DI,
				this.MENU_LIST.VB_DI_DUTHAO,
				this.MENU_LIST.VB_DI_DAPHATHANH,
                // Công việc
				this.MENU_LIST.CONGVIEC,
				this.MENU_LIST.CONGVIEC_GIAO,
				this.MENU_LIST.CONGVIEC_DUOCGIAO,
				this.MENU_LIST.CONGVIEC_DONVI,
				this.MENU_LIST.CONGVIEC_LIENQUAN,
                // Hành chinh
				this.MENU_LIST.HANHCHINH,
				this.MENU_LIST.HANHCHINH_DANGKYPHONGHOP,
				this.MENU_LIST.HANHCHINH_YEUCAUDIEUXE,
				this.MENU_LIST.HANHCHINH_DANGKYLICHTUAN,
                // Cấu hình
				this.MENU_LIST.XEM_THONG_BAO,
				this.MENU_LIST.DANHBA,
				this.MENU_LIST.KHOTAILIEU,
				this.MENU_LIST.THAO_LUAN,
			],

			VAN_THU: [
                // Văn bản đến
				this.MENU_LIST.VB_DEN,
				this.MENU_LIST.VB_DEN_DAXULY_VT,
				this.MENU_LIST.VB_DEN_CHOXULY,
				this.MENU_LIST.VB_DEN_CHOTIEPNHAN,
				this.MENU_LIST.VB_DEN_DATIEPNHAN,
                // Văn bản đi
				this.MENU_LIST.VB_DI,
				this.MENU_LIST.VB_DI_DUTHAO,
				this.MENU_LIST.VB_DI_CHOBANHANH,
				this.MENU_LIST.VB_DI_DABANHANH,
                // Sổ
				this.MENU_LIST.QL_SOVANBAN,
				this.MENU_LIST.QL_SOVANBAN_BOOKSO,
				this.MENU_LIST.QL_SOVANBAN_SODEN,
				this.MENU_LIST.QL_SOVANBAN_SODI,
                // Công việc
				this.MENU_LIST.XEM_THONG_BAO,
				this.MENU_LIST.DANHBA,
				this.MENU_LIST.KHOTAILIEU,
				this.MENU_LIST.THAO_LUAN,
			],

			CHUYEN_VIEN: [
                // Văn bản đến
				this.MENU_LIST.VB_DEN,
				this.MENU_LIST.VB_DEN_DAXULY,
				this.MENU_LIST.VB_DEN_CHOXULY,
                // Văn bản đi
				this.MENU_LIST.VB_DI,
				this.MENU_LIST.VB_DI_DUTHAO,
				this.MENU_LIST.VB_DI_DAPHATHANH,
                // Công việc
				this.MENU_LIST.CONGVIEC,
				this.MENU_LIST.CONGVIEC_GIAO,
				this.MENU_LIST.CONGVIEC_DUOCGIAO,
				this.MENU_LIST.CONGVIEC_LIENQUAN,
                // Hành chính
				this.MENU_LIST.HANHCHINH,
				this.MENU_LIST.HANHCHINH_DANGKYPHONGHOP,
				this.MENU_LIST.HANHCHINH_YEUCAUDIEUXE,
				this.MENU_LIST.HANHCHINH_DANGKYLICHTUAN,
				// 
				this.MENU_LIST.XEM_THONG_BAO,
				this.MENU_LIST.DANHBA,
				this.MENU_LIST.KHOTAILIEU,
				this.MENU_LIST.THAO_LUAN,
			],

			ADMIN: [
				this.MENU_LIST.CAUHINH,
				this.MENU_LIST.CAUHINH_LUONGVANBAN,
				this.MENU_LIST.CAUHINH_QUANLYDANHMUC,
				this.MENU_LIST.CAUHINH_QUANLYNGAYLE,
				this.MENU_LIST.CAUHINH_QUANLYUYQUYEN,
				this.MENU_LIST.CAUHINH_QUANLYVAITRO,
				this.MENU_LIST.CAUHINH_QUANTRIDONVI,
				this.MENU_LIST.CAUHINH_QUANTRINGUOIDUNG,
				this.MENU_LIST.CAUHINH_QUANLYPHONGHOP,
				this.MENU_LIST.CAUHINH_QUANLYTAIXE,
				this.MENU_LIST.XEM_THONG_BAO,
				this.MENU_LIST.THONG_BAO_NOI_BO,
				this.MENU_LIST.THONG_BAO_HE_THONG,
				this.MENU_LIST.KHOTAILIEU,
				this.MENU_LIST.THAO_LUAN,
			],

			ADMIN_DONVI: [
				this.MENU_LIST.CAUHINH,
				this.MENU_LIST.CAUHINH_QUANLYPHONGHOP,
				this.MENU_LIST.CAUHINH_QUANLYTAIXE,
				this.MENU_LIST.CAUHINH_QUANLYXE,
			]
		};
	},

	MENU_LIST_ACCESSIBLE() {
		return {
			NOT_DEPARTMENT: [
				this.MENU_LIST.XEM_THONG_BAO,
				this.MENU_LIST.THONG_BAO_HE_THONG,
				this.MENU_LIST.THONG_BAO_NOI_BO
			],
			LANH_DAO: [
				this.MENU_LIST.VB_DEN,
				this.MENU_LIST.VB_DEN_DAXULY,
				this.MENU_LIST.VB_DEN_CHOXULY,
				this.MENU_LIST.VB_DI_DA_XOA,
				this.MENU_LIST.VB_DEN_TO_TRINH_QUA_HAN,
				this.MENU_LIST.VB_DI,
				this.MENU_LIST.VB_DI_DUTHAO,
				this.MENU_LIST.VB_DI_DAPHATHANH,
				this.MENU_LIST.CONGVIEC,
				this.MENU_LIST.CONGVIEC_GIAO,
				this.MENU_LIST.CONGVIEC_DUOCGIAO,
				this.MENU_LIST.CONGVIEC_SCORE,
				this.MENU_LIST.CONGVIEC_SCORE_UPDATE,
				this.MENU_LIST.CONGVIEC_DONVI,
				this.MENU_LIST.CONGVIEC_LIENQUAN,
				this.MENU_LIST.HANHCHINH,
				this.MENU_LIST.HANHCHINH_DANGKYPHONGHOP,
				this.MENU_LIST.HANHCHINH_YEUCAUDIEUXE,
				this.MENU_LIST.HANHCHINH_DANGKYLICHTUAN,
				this.MENU_LIST.HANHCHINH_THEODOIKETLUANCHIDAO,
				this.MENU_LIST.HANHCHINH_VEMAYBAY,
				this.MENU_LIST.HANHCHINH_KHACHSAN,
				this.MENU_LIST.VB_DEN_UYQUYEN,
				this.MENU_LIST.CAUHINH,
				this.MENU_LIST.CAUHINH_QUANLYUYQUYEN,
				this.MENU_LIST.CAUHINH_RANKINGREASON,
				this.MENU_LIST.BAOCAO,
				this.MENU_LIST.BAOCAO_VBTHEOTRANGTHAI,
				this.MENU_LIST.BAOCAO_TINHHINHXLVB,
				this.MENU_LIST.BAOCAO_QLCV_TIENDOHOANTHANHCV,
				this.MENU_LIST.BAOCAO_QLCV_TONGHOPTHANG,
				this.MENU_LIST.BAOCAO_QLCV_RANKING_TONGHOP,
				this.MENU_LIST.BAOCAO_QLCV_RANKING_TRUNGBINHTHANG,
				this.MENU_LIST.THONG_BAO_HE_THONG,
				this.MENU_LIST.THONG_BAO_NOI_BO,
				this.MENU_LIST.XEM_THONG_BAO,
				this.MENU_LIST.DANHBA,
				this.MENU_LIST.KHOTAILIEU,
				this.MENU_LIST.THAO_LUAN,
				this.MENU_LIST.QUAN_LY_TIN_TUC,
			],

			VAN_THU: [
				this.MENU_LIST.VB_DEN,
				this.MENU_LIST.VB_DEN_DAXULY_VT,
				this.MENU_LIST.VB_DEN_DAXULY,
				this.MENU_LIST.VB_DEN_CHOXULY,
				this.MENU_LIST.VB_DI_DA_XOA,
				this.MENU_LIST.VB_DEN_CHOTIEPNHAN,
				this.MENU_LIST.VB_DEN_DATIEPNHAN,
				this.MENU_LIST.VB_DI,
				this.MENU_LIST.VB_DI_DUTHAO,
				this.MENU_LIST.VB_DI_CHOBANHANH,
				this.MENU_LIST.VB_DI_DABANHANH,
				this.MENU_LIST.QL_SOVANBAN,
				this.MENU_LIST.QL_SOVANBAN_BOOKSO,
				this.MENU_LIST.QL_SOVANBAN_SODEN,
				this.MENU_LIST.QL_SOVANBAN_SODI,
				this.MENU_LIST.CONGVIEC,
				this.MENU_LIST.CONGVIEC_GIAO,
				this.MENU_LIST.CONGVIEC_DUOCGIAO,
				this.MENU_LIST.CONGVIEC_DONVI,
				this.MENU_LIST.CONGVIEC_LIENQUAN,
				this.MENU_LIST.BAOCAO,
				this.MENU_LIST.BAOCAO_VBTHEOSO,
				this.MENU_LIST.VB_DI_LUONGVB,
				this.MENU_LIST.BAOCAO,
				this.MENU_LIST.BAOCAO_VBTHEOTRANGTHAI,
				this.MENU_LIST.BAOCAO_TINHHINHXLVB,
				this.MENU_LIST.THONG_BAO_HE_THONG,
				this.MENU_LIST.THONG_BAO_NOI_BO,
				this.MENU_LIST.XEM_THONG_BAO,
				this.MENU_LIST.DANHBA,
				this.MENU_LIST.KHOTAILIEU,
				this.MENU_LIST.THAO_LUAN,
				this.MENU_LIST.QUAN_LY_TIN_TUC,
			],

			CHUYEN_VIEN: [
				this.MENU_LIST.VB_DEN,
				this.MENU_LIST.VB_DEN_DAXULY,
				this.MENU_LIST.VB_DEN_CHOXULY,
				this.MENU_LIST.VB_DI_DA_XOA,
				this.MENU_LIST.VB_DI,
				this.MENU_LIST.VB_DI_DUTHAO,
				this.MENU_LIST.VB_DI_DAPHATHANH,
				this.MENU_LIST.CONGVIEC,
				this.MENU_LIST.CONGVIEC_GIAO,
				this.MENU_LIST.CONGVIEC_DUOCGIAO,
				this.MENU_LIST.CONGVIEC_SCORE,
				this.MENU_LIST.CONGVIEC_SCORE_UPDATE,
				this.MENU_LIST.CONGVIEC_DONVI,
				this.MENU_LIST.CONGVIEC_LIENQUAN,
				this.MENU_LIST.HANHCHINH,
				this.MENU_LIST.HANHCHINH_DANGKYPHONGHOP,
				this.MENU_LIST.HANHCHINH_YEUCAUDIEUXE,
				this.MENU_LIST.HANHCHINH_DANGKYLICHTUAN,
				this.MENU_LIST.HANHCHINH_THEODOIKETLUANCHIDAO,
				this.MENU_LIST.HANHCHINH_VEMAYBAY,
				this.MENU_LIST.HANHCHINH_KHACHSAN,
				this.MENU_LIST.SUA_CHUA_NHO,
				this.MENU_LIST.BAOCAO,
				this.MENU_LIST.BAOCAO_VBTHEOTRANGTHAI,
				this.MENU_LIST.BAOCAO_TINHHINHXLVB,
				this.MENU_LIST.BAOCAO_QLCV_TIENDOHOANTHANHCV,
				this.MENU_LIST.BAOCAO_QLCV_TONGHOPTHANG,
				this.MENU_LIST.CAUHINH_RANKINGREASON,
				this.MENU_LIST.BAOCAO_QLCV_RANKING_TONGHOP,
				this.MENU_LIST.BAOCAO_QLCV_RANKING_TRUNGBINHTHANG,
				this.MENU_LIST.THONG_BAO_HE_THONG,
				this.MENU_LIST.THONG_BAO_NOI_BO,
				this.MENU_LIST.XEM_THONG_BAO,
				this.MENU_LIST.DANHBA,
				this.MENU_LIST.KHOTAILIEU,
				this.MENU_LIST.THAO_LUAN,
				this.MENU_LIST.QUAN_LY_TIN_TUC,
			],

			ADMIN: [
				this.MENU_LIST.CAUHINH,
				this.MENU_LIST.CAUHINH_LUONGVANBAN,
				this.MENU_LIST.CAUHINH_QUANLYDANHMUC,
				this.MENU_LIST.CAUHINH_QUANLYNGAYLE,
				this.MENU_LIST.CAUHINH_QUANLYUYQUYEN,
				this.MENU_LIST.CAUHINH_QUANLYVAITRO,
				this.MENU_LIST.CAUHINH_QUANTRIDONVI,
				this.MENU_LIST.CAUHINH_QUANTRINGUOIDUNG,
				this.MENU_LIST.CAUHINH_QUANLYPHONGHOP,
				this.MENU_LIST.CAUHINH_QUANLYTAIXE,
				this.MENU_LIST.THUVIEN_VANBANMAU,
				this.MENU_LIST.CAUHINH_RANKINGREASON,
				this.MENU_LIST.CAUHINH_QUANLYXE,
				this.MENU_LIST.CAUHINH_DOCUMENTTYPE,
				this.MENU_LIST.CAUHINH_THAOLUAN,
				this.MENU_LIST.CAUHINH_HINHNEN,
				this.MENU_LIST.CAUHINH_QUANLYXE,
				this.MENU_LIST.CAUHINH_QUANLYXE,
				this.MENU_LIST.THONG_BAO_HE_THONG,
				this.MENU_LIST.THONG_BAO_NOI_BO,
				this.MENU_LIST.XEM_THONG_BAO,
				this.MENU_LIST.DANHBA,
				this.MENU_LIST.KHOTAILIEU,
				this.MENU_LIST.THAO_LUAN,
				this.MENU_LIST.QUAN_LY_TIN_TUC,
			],

			ADMIN_DONVI: [
				this.MENU_LIST.CAUHINH,
				this.MENU_LIST.CAUHINH_QUANLYPHONGHOP,
				this.MENU_LIST.CAUHINH_QUANLYTAIXE,
				this.MENU_LIST.CAUHINH_QUANLYXE,
				this.MENU_LIST.THONG_BAO_HE_THONG,
				this.MENU_LIST.THONG_BAO_NOI_BO,
				this.MENU_LIST.XEM_THONG_BAO,
				this.MENU_LIST.DANHBA,
				this.MENU_LIST.KHOTAILIEU,
				this.MENU_LIST.THAO_LUAN,
				this.MENU_LIST.QUAN_LY_TIN_TUC,
			],

			OTHER: [
				this.MENU_LIST.CAUHINH,
				this.MENU_LIST.CAUHINH_QUANLYPHONGHOP,
				this.MENU_LIST.CAUHINH_QUANLYTAIXE,
				this.MENU_LIST.CAUHINH_QUANLYXE,
				this.MENU_LIST.HANHCHINH,
				this.MENU_LIST.HANHCHINH_DANGKYPHONGHOP,
				this.MENU_LIST.HANHCHINH_YEUCAUDIEUXE,
				this.MENU_LIST.HANHCHINH_DANGKYLICHTUAN,
				this.MENU_LIST.THONG_BAO_HE_THONG,
				this.MENU_LIST.THONG_BAO_NOI_BO,
				this.MENU_LIST.XEM_THONG_BAO,
				this.MENU_LIST.DANHBA,
				this.MENU_LIST.KHOTAILIEU,
				this.MENU_LIST.THAO_LUAN,
				this.MENU_LIST.QUAN_LY_TIN_TUC,
			]
		};
	},

	OUTGOING_DOC_STATUS: {
		TAOMOI: 0,
		DANGXULI: 1,
		DAXULY: 2,
		DABANHANH: 3,
		CHO_BAN_HANH: 4,
		DA_THU_HOI: 5,
		TU_CHOI: 6,
		TU_CHOI_BAN_HANH: 7
	},
	READ_STATUS: {
		READED: 1,
		UN_READ: 0
	},

	DOC_TYPE: {
		VB_DEN: 0,
		VB_DI: 1
	},

	CATEGORY_GROUP_CODE: {
		PRIORITY: "VOFFICE_CAT_URGENCY",
		DOC_TYPE: "VOFFICE_CAT_DOCTYPE",
		SECRET_LEVEL: "VOFFICE_CAT_SECRET",
		DOC_RELATION_TYPE: "DOC_RELATION_TYPE",
		TASK_PRIORITY: "TASK_PRIORITY",
		POSITION: "POSITION",
		HC_COMMAND_SECTOR: "hcCommand.sector",
		HC_HOTEL_LOCATION: "hcHotel.location",
		HC_HOTEL_HOTEL: "hcHotel.hotel",
		HC_SCN_LINH_VUC: "hcScn.linhvuc"
	},

	ATTACHMENT_OBJECT_TYPE: {
		VB_DEN: 1,
		VB_DI: 2,
		RELATION_DOC: 5,
		CHU_KY: 3,
		COMMENT: 4,
		TASK: 6,
		BOOKDOC: 8,
		VB_BAOCAOCHIDAO: 9,
		VB_KYTUOI: 10,
		FILE_BAN_HANH_CO_CHU_KY_PDF: 12,
		SIGNATURE: 20,
		STAMP: 21,
		TOTRINH_VEMAYBAY: 30,
		VEMAYBAY: 31,
		TOTRINH_KHACHSAN: 32,
		KHACHSAN: 33,
		VB_DI_SIGNED_WITH_TOKEN: 16,
		VB_DI_SIGNED_WITH_TOKEN_WITHOUT_STAMP: 17,
		VB_DI_REFERENCE_ATTACHMENT: 14,
		SHARE_LIBRARY: 69,
		PHIEU_Y_KIEN: 40,
		LICH_TUAN: 41,
		HC_DOC_RELATION: 42
	},

	DOC_RELATION_OBJECT_TYPE: {
		ATTACHMENT: 2,
		OUTGOING_DOC: 1,
		VB_DEN: 0
	},
	DOC_RELATION_ATTACHED_TYPE: {
		ATTACHED: 0,
		NO_ATTACHED: 1,
		PHIEU_Y_KIEN: 2,
		SCAN: 3,
	},

	RECEIVER_OBJECT_TYPE: {
		// Phan loai Doi tuong nhan van ban
		DONVI: 0, // Don vi
		CANHAN: 1, // Ca nhan
		DONVI_BENNGOAI: 2, //đơn vị bên ngoài
		DONVI_TRUCLIENTHONG: 3 //đơn vị bên ngoài
	},
	RECEIVE_STATUS: {
		CHO_PHAN_HOI: "choPhanHoi",
		DA_DEN: "daNhan",
		TU_CHOI_TIEP_NHAN: "tuChoiTiepNhan",
		TIEP_NHAN: "tiepNhan",
		PHAN_CONG: "phanCong",
		DANG_XU_LY: "dangXuLy",
		HOAN_THANH: "hoanThanh",
		LAY_LAI: "layLai"
	},

	DOC_USER_STATUS: {
		CHO_XU_LY: 0,
		DA_XU_LY: 1,
		NHAN_DE_BIET: 2,
		TU_CHOI: 3,
		BAN_HANH: 6
	},

	VIA_LETTER: {
		QUA_VANTHU: 1,
		K_QUA_VANTHU: 2
	},

	ACTION_LOG_OBJECT_TYPE: {
		VB_DI: 0,
		VB_DEN: 1,
		COMMENT: 2,
		CONG_VIEC: 3
	},

	ACTION_LOG_ACTION_NAME: {
		UPDATE: "update",
		BAN_GIAO: "banGiaoVbDi",
		INSERT: "insert",
		CHUYENXULI: "chuyenXuLi",
		TOKENCHUYENXULI: "kyTokenChuyenXuLi",
		CHOYKIEN: "choYKien",
		HIEUCHINH: "hieuChinh",
		HIEUCHINH_BANHANH: "hieuChinhBanHanh",
		BANHANH_CANHAN: "banHanhCaNhan",
		HIEUCHINH_BANHANH_CANHAN: "hieuChinhBanHanhCaNhan",
		KYSO_CHUYENXULI: "kySoChuyenXuLi",
		CHOBANHANH: "choBanHanh",
		PHE_DUYET: "pheDuyet",
		TUCHOI: "tuChoi",
		TUCHOITIEPNHAN: "tuChoiTiepNhan",
		TUCHOIBANHANH: "tuChoiBanHanh",
		TUCHOI_GHICHU_VB: "tuChoiGhiChuVb",
		BANHANH: "banHanh",
		BANHANHV2: "banHanhV2",
		BANHANH_TOI: "banHanhToi",
		UPDATE_INCOMING_DOC: "updateIncomingDoc",
		KETTHUC: "kethuc",
		THUHOI: "thuHoi",
		THUHOI_BANHANH: "thuHoiBanHanh",
		THUHOI_BANHANHV2: "thuHoiBanHanhV2",
		CHUYENXULI_DONVI: "chuyenXuLiDonVi",
		CC: "cc",
		Thu_Hoi_CC: "thuHoiCC",
		LANHDAO_TUCHOI: "lanhDaoTuChoi",
		TASK_TAO_MOI_CONGVIEC: "TASK_TAO_MOI_CONGVIEC",
		TASK_UPDATE_CONGVIEC: "TASK_UPDATE_CONGVIEC",
		TASK_TU_CHOI_HOAN_THANH: "TASK_TU_CHOI_HOAN_THANH",
		TASK_APPROVE_HOAN_THANH: "TASK_APPROVE_HOAN_THANH",
		TASK_HOAN_THANH: "TASK_HOAN_THANH",
		TASK_PHE_DUYET_DK: "TASK_PHE_DUYET_DK",
		TASK_TU_CHOI_DK: "TASK_TU_CHOI_DK",
		TASK_TAM_DUNG: "TASK_TAM_DUNG",
		TASK_KHOI_DONG: "TASK_KHOI_DONG",
		TASK_HUY: "TASK_HUY",
		TASK_UPDATE_TASK_PROGRESS: "TASK_UPDATE_TASK_PROGRESS",
		TASK_UPDATE_RECEIVER: "TASK_UPDATE_RECEIVER",
		DA_DEN: "daDenTltvb",
		DA_NHAN: "daNhanTltvb",
		TU_CHOI_TIEP_NHAN: "tltvbTuChoiTiepNhan",
		TIEP_NHAN: "tiepNhanTltvb",
		PHAN_CONG: "tltvbPhanCong",
		DANG_XU_LY: "tltvbDangXuLy",
		HOAN_THANH: "tltvbHoanThanh",
		DONG_Y: "dongYTltvb",
		TU_CHOI: "tuChoiTltvb",
		HE_THONG_BAN_HANH: "banHanhTltvb",
		TRA_LAI: "tltvbTraLai",
		TU_CHOI_TRA_LAI: "tltvbTuChoiTraLai",
		GUI_YEU_CAU_THUHOI_BANHANH: "guiYeuCauThuHoiBanHanh",
		THU_HOI_BAN_HANH_V2: "thuHoiBanHanhV2",
		HIEUCHINHV2: "hieuChinhV2",

		VB_INCOMING_DOC: {
			CHUYENXULI_V2: "vbIncomingDoc.cxl"
		},

		TK_TASK: {
			DELETE: "tkTask.delete",
			CHANGE_DEADLINE: "tkTask.changeDeadline"
		},

		CHI_DAO: {
			TAO_MOI: "taoMoi",
			CAP_NHAT: "capNhat",
			BAO_CAO_TIEN_DO: "baoCaoTienDo",
			BAO_CAO_HOAN_THANH: "baoCaoHoanThanh",
			GIA_HAN: "giaHan",
			PHE_DUYET: "pheDuyet",
			YEU_CAU_BO_SUNG: "yeuCauBoSung",
			DANG_KY_DEADLINE: "dangKyDeadline",
			HUY_YEU_CAU: "huyYeuCau",
			BAO_TRUNG_CHI_DAO: "baoTrungChiDao",
			CHO_Y_KIEN: "choYKien"
		},

		VB_OUTGOING_DOC: {
			SUA_SAI: "vbOutgoingDoc.suaSai"
		},

		QUANLY_TAILIEU: {
			THEM: "insert",
			SUA: "update",
			XOA: "delete",
		},
	},

	COMMENT_OBJECT_TYPE: {
		VB_DI: 0,
		VB_DEN: 1,
		TASK: 2
	},

	OUTGOING_PROCESS_STATUS: {
		CHO_XU_LY: 0,
		DA_XU_LY: 1,
		TU_CHOI: 3
	},

	INCOMING_PROCESS_STATUS: {
		CHO_XU_LY: 0,
		DA_XU_LY: 1,
		NHAN_DE_BIET: 2,
		TU_CHOI: 3,
		KETTHUC: 4
	},
	STEP_POS_TYPE: {
		BAT_DAU: 1,
		KET_THUC: 2,
		BOTH: 3
	},

	BOOK_TYPE: {
		VB_DEN: 0,
		VB_DI: 1
	},

	FLOW_TYPE: {
		VB_DEN: 1,
		VB_DI: 2,
		DONG_TRINH: 3
	},

	STEP_INFO_PROCESS_TYPE: {
		CHU_TRI: "chuTri",
		PHOI_HOP: "phoiHop",
		NHAN_DE_BIET: "nhanDeBiet"
	},

	STEP_INFO_SIGN_TYPE: {
		KI_SO: 2
	},

	PROCESS_TYPE: {
		CHUTRI: 0,
		NHANDEBIET: 1,
		PHOIHOP: 2
	},

	PERMISSION: {
		VIEW: 0,
		CREATE: 1,
		UPDATE: 2,
		DELETE: 3,
	},

	TASK_DOC_RELATION: {
		VB_DI: 0,
		VB_DEN: 1
	},

	ADD_DOCS_DIALIG_DOC_TYPE: {
		VB_DI: 0,
		VB_DEN: 1
	},

	// -- Khẩn,15
	// -- Bình thường,16
	// -- Thượng khẩn,17
	// -- Hỏa tốc hẹn giờ,25
	// -- Hỏa tốc,26
	HIGH_LEVELS_PIORITY_IDS: ["15", "17", "25", "26"],

	// Tối mật,27
	// Bình thường,12
	// Mật,13
	// Tuyệt Mật,14
	HIGH_LEVELS_SECURITY_IDS: ["13", "14", "27"],

	TASK_TASK_TYPE: {
		DANGKI: "dangKi",
		GIAOVIEC: "giaoViec"
	},

	TASK_ASSIGN_PROCESS_TYPE: {
		XULICHINH: 1,
		PHOIHOP: 2
	},

	TASK_STATUS: {
		CHO_PHE_DUYET_DK: 0,
		DANG_THUC_HIEN: 1,
		HUY_PHE_DUYET_DK: 2,
		HOAN_THANH: 3,
		KET_THUC: 4,
		HUY: 5,
		TAM_DUNG: 6
	},

	NOTIFI_STATUS: {
		LUU_TAM: 1,
		DA_GUI: 2,
	},

	DOC_STATUS: {
		CHO_DUYET: 1,
		DA_DUYET: 2,
		TU_CHOI: 3,
	},

	DISCUSS_STATUS: {
		C_CHODUYET: 1,
		U_CHODUYET: 2,
		DADUYET: 4,
		TUCHOI: 3,
		CUATOI: 5,
		REPORT: 6,
		DELETE: 7,
	},

	JOB_INDEX_PAGE: {
		FILTER_STATUS: {
			DANG_THUC_HIEN: "dangThucHien",
			HOAN_THANH: "hoanThanh",
			TAM_DUNG: "tamDung",
			CHO_PHE_DUYET: "choPheDuyet",
			KET_THUC: "ketThuc",
			UY_QUYEN: "uyQuyen"
		},

		VIEW_TYPE: {
			RECEIVER: "receiver",
			ASSIGNER: "assigner",
			DEPT_ASSIGNER: "allInDept",
			COORDINATOR: "coordinator"
		}
	},

	NOTI_INDEX_PAGE: {
		STATUS: {
			LUU_TAM: "luuTam",
			DA_GUI: "daGui",
		},
	},

	INCOMING_DOC_STATUS: {
		TAO_MOI: 0,
		DANG_XU_LY: 1,
		NHAN_DE_BIET: 2,
		DA_HOAN_THANH: 3,
		DA_THU_HOI: 4,
		TU_CHOI: 6,
		KET_THUC: 7,
		TU_CHOI_TIEP_NHAN: 8
	},

	INCOMING_DOC: {
		CHUA_VAO_SO: 0,
		DA_VAO_SO: 1
	},

	USER_CONFIG: {
		NOTIFY: {
			THEO_GIO: 1,
			LAP_TUC: 2
		}
	},

	DOCUMENT_FILE: {
		MAX_SIZE: 50 * 1024 * 1024,
		ACCEPT_TYPES: [".pdf"].join(","),
		ACCEPT_TYPES_DOC_OUT: [".pdf"].join(","),
		ACCEPT_TYPES_SHARE_LIB: [
			".pdf",
			".doc",
			".docx",
			".xls",
			".xlsx",
			".png",
			".jpg"
		].join(",")
	},

	FLOW_INSTANCE_STATUS: {
		// Trang thai cua van ban di
		DANG_XU_LY: 1, // Van ban dang xu ly
		DA_BAN_HANH: 3, // Van ban ban hanh
		KET_THUC: 4, // Van ban cho ban hanh
		DA_THU_HOI: 5, // Van ban da thu hoi
		TU_CHOI: 6, // Van ban da thu hoi
		PROCESSING: 7, // Luong hanh chinh dang xu ly
		COMPLETED: 8, // Luong hanh chinh da hoan thanh
		CANCELED: 9, // Luong hanh chinh da bi huy
		TU_CHOI_BAN_HANH: 10 // Luong hanh chinh da bi huy
	},

	USERS: {
		STATUS: {
			ACTIVE: "active",
			DEACTIVE: "deactive"
		},
		GENDER: {
			MALE: 0,
			FEMALE: 1
		}
	},
	USER_DEPT_ROLE: {
		STATUS: {
			ACTIVE: "active",
			DEACTIVE: "deactive"
		}
	},
	BOOK_DOC_TYPE: {
		STATUS: {
			ACTIVE: "active",
			DEACTIVE: "deactive"
		}
	},
	DEPARTMENT: {
		DEPT_CODE: {
			TCT: "TCT",
			TOGIUPVIEC_HDTV: "TGVHDTV-TCT"
		},
		DEPT_TYPE: {
			PBCN: "phongBanChucNang",
			DVTT: "donViTrucThuoc"
		},
		STATUS: {
			ACTIVE: "active",
			DEACTIVE: "deactive"
		},
		NEED_TO_SIGNCA: {
			ACTIVE: 1
		},
		IS_AUTO_CXL: {
			ACTIVE: 1
		},
		DEPT_PATH: {
			TCT_PATH: "/TCT"
		},
		LIST_DEPT_TYPE: [
			{
				id: 1,
				value: "phongBanChucNang",
				label: "Phòng, Ban, Trung tâm"
			},
			{
				id: 2,
				value: "donViTrucThuoc",
				label: "Các chi nhánh"
			}
		]
	},

	DEPARTMENT_TREE: {
		NODE_TYPE: {
			PBCN: "phongBanChucNang",
			DVTT: "donViTrucThuoc",
			PBCNAndDVTT: "phongBanChucNangVaDonViTrucThuoc",
			DEPT: "dept",
			USER_DEPT_ROLE: "userDeptRole",
			HDTV: "hoiDongThanhVien",
			BTGD: "banTongGiamDoc",
			TVHDQT: "tvhdqt",
			KTT: "keToanTruong",
			BKS: "banKiemSoat",
		}
	},

	POSITION: {
		NAME: {
			THANH_VIEN_HDTV: "Thành viên Hội đồng thành viên",
			TGĐ: "Tổng giám đốc",
			PTGĐ: "Phó Tổng giám đốc"
		},
		CODE: {
			PHO_CHANH_VP: "pcvp",
			THU_KY: "Tk"
		}
	},

	DATE_QUICK_FILTER: {
		CODE: {
			HOM_NAY: "homNay",
			TUAN_NAY: "tuanNay",
			NAM_NAY: "namNay",
			LAST_WEEK: "tuanTruoc",
			LAST_30_DAYS: "30NgayGanNhat",
			LAST_YEAR: "namGanNhat",
			THIS_MONTH: "thangNay",
			THIS_MONTH_2: "thangNay2",
			LAST_MONTH: "thangTruoc",
			LAST_YEAR_2: "namNgoai",
			TO_TRINH_QUA_HAN_DEFAULT_RANGE: "toTrinhQuaHanDefaultRange"
		}
	},

	DIAGRAM: {
		NODE: {
			TYPE: {
				START_NODE: "startNode"
			}
		}
	},

	MENU_CONFIG: {
		STATUS: {
			ACTIVE: "active",
			DEACTIVE: "deactive"
		}
	},

	DELEGATE: {
		STATUS: {
			ACTIVE: "1",
			DEACTIVE: "0"
		},
		TYPE: {
			DOC_PROCESS: "docProcess",
			TASK: "task"
		}
	},

	EVALUATION_POINT: [
		{ score: 1, value: "Yếu kém", shortValue: "Yếu" },
		{ score: 2, value: "Yếu kém", shortValue: "Yếu" },
		{ score: 3, value: "Yếu kém", shortValue: "Yếu" },
		{ score: 4, value: "Yếu kém", shortValue: "Yếu" },
		{ score: 5, value: "Chưa đạt yêu cầu", shortValue: "Chưa đạt" },
		{ score: 6, value: "Đạt yêu cầu", shortValue: "Đạt" },
		{ score: 7, value: "Đạt yêu cầu", shortValue: "Đạt" },
		{ score: 8, value: "Tốt", shortValue: "Tốt" },
		{ score: 9, value: "Tốt", shortValue: "Tốt" },
		{ score: 10, value: "Xuất sắc", shortValue: "Xuất sắc" }
	],

	STEP: {
		STEP_TYPE: {
			DONVI: "donVi",
			CANHAN: "caNhan"
		}
	},

	VB_FLOW: {
		STATUS: {
			ACTIVE: "active",
			DEACTIVE: "deactive"
		},
		DEFAULT: {
			IS_DEFAULT: 1,
			NOT_DEFAULT: 0
		},
		FLOW_CODE: {
			LUONG_TRINH_BAN_TGD: "luongTrinhBanTGD"
		}
	},
	VB_STEP: {
		STATUS: {
			ACTIVE: "active",
			DEACTIVE: "deactive"
		}
	},
	VB_STEP_INFO: {
		STATUS: {
			ACTIVE: "active",
			DEACTIVE: "deactive"
		}
	},
	CATEGORY: {
		STATUS: {
			ACTIVE: "active",
			DEACTIVE: "deactive"
		},

		CODE: {
			DOC_TYPE: {
				TO_TRINH_XIN_Y_KIEN_HDTV: "ttrhdtv",
				GIAI_TRINH_Y_KIEN_HDTV: "gtrhdtv",
				PHIEU_Y_KIEN: "phieuykien",
				TO_TRINH: "ttr"
			}
		}
	},
	DOWNLOAD_OPTION: {
		TYPE: {
			SIGNATURE: "signature",
			STAMP: "stamp",
			ORIGINAL: "original",
			PDF: "pdf",
			IMAGE: "image",
			TRANG_KY_SO: "trangKySo"
		}
	},

	DEFAULT_ACCEPTED_CONTENT_TYPE: [
		"application/pdf",
		"application/msword",
		"application/vnd.openxmlformats-officedocument.wordprocessingml.document"
	],
	ACCEPTED_CONTENT_TYPE_SHARE_LIB: [
		"application/pdf",
		"application/msword",
		"application/vnd.ms-excel",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		"image/png",
		"image/jpeg",
		"application/vnd.openxmlformats-officedocument.wordprocessingml.document"
	],
	DEFAULT_ACCEPTED_CONTENT_TYPE_DOC_OUT: ["application/pdf"],
	DEFAULT_ACCEPTED_CONTENT_TYPE_ALL: "*",
	DEFAULT_MAX_FILE_SIZE_MB: 50,
	DEFAULT_BLACK_LIST_EXTS: "exe,chm,pif,reg,scr,sct,hlp,shs,shb,msi,msp,msc,class,com,dll,dmg,drv,grp,ocx,ovl,sys,vdl,vxd,js,jse,vb,vbe,vbs?,pcd,?wsc,wsf,wsh,ws?,hta,?js,jse,vb,vbe,vbs?,pcd,?wsc,wsf,wsh,ws?,hta,cmd,bat,?acc,asp,ccs,htx,je,php,php3,sbs,sct,shb,shd,vba,ws,wst,jar,ps1,ps1xml,ps2,ps2xml,psc1,psc2,msh,msh1,msh2,mshxml,msh1xml,msh2xml,lnk,scf,ink,cpl,crt,ins,isp,ade,adp,ldb,mad,mda,mdb,mdz,snp,bas,mde,mst,html,svg"
		.toLowerCase()
		.split(","),

	EVENT_BUS: {
		CHANGE_USER_DEPT_ROLE: "changeUserDeptRole",
		CATCH_ERROR_RESPONSE: "catchErrorResponse"
	},

	ROLE: {
		CODE: {
			LANH_DAO: "lanhdao",
			VAN_THU: "vanthu",
			CHUYEN_VIEN: "chuyenvien",
			ADMIN: "admin",
			TONG_HOP_LICH_TUAN: "tonghoplichtuan",
			DANG_KY_LICH_TUAN: "DKLICHTUAN",
			TONG_HOP_BAO_CAO: "tonghopbaocao",

			DIEU_XE: {
				QUAN_LY_XE: "quanlyxe"
			},

			KHACH_SAN: {
				DUYET_KHACH_SAN: "THKHACHSAN"
			},

			PHONG_HOP: {
				QL_PHONG_HOP: "quanlyphonghop"
			},

			HANH_CHINH: {
				QL_HANH_CHINH: "quanlyhanhchinh"
			},

			SUA_CHUA_NHO: {
				DUYET_SUA_CHUA_NHO: "THSUACHUANHO"
			}
		}
	},

	DOWNLOAD_FILE_URL: {
		DEFAULT_URL: "vbAttachmentToken/secure/downloadFile",
		DOWNLOAD_FILE_COMMON: "vbAttachmentToken/secure/downloadFileCommon",
		OUTGOING_URL: "vbAttachmentToken/secure/downloadFileOutgoing",
		OUTGOING_URL_VT: "vbAttachmentToken/secure/downloadFileOutgoingVT",
		OUTGOING_WITH_TOKEN_URL:
			"vbAttachmentToken/secure/downloadFileOutgoingWithToken",
		OUTGOING_WITH_TOKEN_URL_VT:
			"vbAttachmentToken/secure/downloadFileOutgoingWithTokenVT",
		REFERENCE_OUTGOING_URL:
			"vbAttachmentToken/secure/downloadFileReferenceOutgoing",
		REFERENCE_OUTGOING_URL_VT:
			"vbAttachmentToken/secure/downloadFileReferenceOutgoingForVT",
		DOWNLOAD_FILE_DOC_RELATE_TASK:
			"vbAttachmentToken/secure/downloadFileDocRelateWithTask",
		DOWNLOAD_FILE_INCOMING_DOC:
			"vbAttachmentToken/secure/downloadFileIncomingDoc",
		DOWNLOAD_FILE_SHARE_LIBRARY:
			"vbAttachmentToken/secure/downloadFileShareLibrary",
		DOWNLOAD_HC_COMMANDS_DOC_RELATION:
			"vbAttachmentToken/secure/downloadFileForHcCommandsDocRelation"
	},

	BOOKDOC: {
		STATUS: {
			ACTIVE: "active",
			DEACTIVE: "unactive",
			DA_BOOK: "active",
			CHUA_BOOK: "unactive",
			HET_DAI: "outOfQuantity"
		}
	},

	VB_INCOMING_DOC: {
		STATUS_VANTHU: {
			CHO_TIEP_NHAN: 0,
			DA_TIEP_NHAN: 1,
			CHO_XU_LY: 2,
			DA_XU_LY: 3
		}
	},

	VB_NOTIFICATION: {
		MESSAGE_TYPE: {
			CC_DOC_IN: "incoming.cc",
			CV_GIAOVIEC: "cv.giaoViec",
			VB_BANGIAO: "outgoing.bangiao",
			CV_DANGKY: "cv.dangKy",
			CV_PHEDUYET: "cv.pheDuyet",
			CV_TUCHOI: "cv.tuChoi",
			CV_TAMDUNG: "cv.tamDung",
			CV_HUY: "cv.huy",
			CV_CHANGE_DEADLINE: "cv.changeDeadline",
			CV_PHEDUYET_HOANTHANH: "cv.pheDuyetHoanThanh",
			CV_TUCHOI_HOANTHANH: "cv.tuChoiHoanThanh",
			CV_HOANTHANH: "cv.hoanThanh",
			CV_CAPNHAT_TIENDO: "cv.capNhatTienDo",
			OUTGOING_COMMENT: "outgoing.comment",
			OUTGOING_KETTHUC: "outgoing.ketThuc",
			THU_HOI_CC: "thuHoiCC",
			INCOMING_COMMENT: "incoming.comment",
			INCOMING_BANHANH: "incoming.banhanh",
			INCOMING_TUCHOI: "incoming.tuchoi",
			CV_CANHBAOQUAHAN: "cv.canhBaoQuaHan",
			RANKING_INSERTRANKINGSCORE: "ranking.insertRankingScore",
			ADDNOTI: "addCommunication",
			ADDNEWS: "addNews",
			DELETE_USERNOTI: "deleteCommunication",
			TAG_COMMENT: "tagComment",
			REPLY_COMMENT: "replyComment",
			APPROVE_DISCUSS: "approveDiscuss",
			DECLINE_DISCUSS: "declineDiscuss",
			DELETE_DISCUSS: "deleteDiscuss",
			ADD_DISCUSS: "addDiscuss",
			SEND_APPROVE_DISCUSS: "sendApproveDiscuss",
			REPORT_COMMENT: "reportComment",

			// Document
			DOCUMENT_APPROVE: "document.daPheDuyet",
			DOCUMENT_CREATE: "document.choPheDuyet",
			DOCUMENT_REJECT: "document.tuChoi",

			TK_TASK: {
				COMMENT: "cv.comment"
			},

			HANH_CHINH: {
				// Phòng họp
				DK_PHONGHOP: "dkPhongHop",
				HUY_PHONG_HOP: "huyPhongHop",
				CAP_NHAT_PHONG_HOP: "capNhatPhongHop",
				PHE_DUYET_PHONG_HOP: "pheDuyetPhongHop",
				TU_CHOI_PHONG_HOP: "tuChoiPhongHop",
				// Điều xe
				DIEU_XE: {
					CAP_NHAT: "capNhatDieuXe",
					HUY_YEU_CAU: "huyYeuCauDieuXe",
					PHE_DUYET: "pheDuyetDieuXe",
					DANG_KY: "dangKyDieuXe",
					TU_CHOI: "tuChoiDieuXe",
				},
				// Lịch tuần
				LICH_TUAN: {
					CAP_NHAT: "capNhatLichTuan",
					HUY_YEU_CAU: "huyLichTuan",
					PHE_DUYET: "pheDuyetLichTuan",
					DANG_KY: "dangKyLichTuan",
					TU_CHOI: "tuChoiLichTuan",
				}
			},

			CHI_DAO: {
				CREATE: "hcCommands.create",
				UPDATE: "hcCommands.update",
				DK_DEADLINE: "hcCommands.dkDeadline",
				GIA_HAN: "hcCommands.giaHan",
				HUY: "hcCommands.huy",
				YCBS: "hcCommands.ycbs",
				PHE_DUYET: "hcCommands.pheDuyet",
				BAO_CAO: "hcCommands.baoCao",
				CHO_Y_KIEN: "hcCommands.choYKien"
			},

			DIEU_XE: {
				CAP_NHAT: "hcDieuXe.capnhat",
				HUY_YEU_CAU: "hcDieuXe.huyyeucau",
				PHE_DUYET: "hcDieuXe.pheduyet",
				DANG_KY: "hcDieuXe.dangky",
				TU_CHOI: "hcDieuXe.tuchoi"
			},

			MAY_BAY: {
				CAP_NHAT: "hcCaseFlight.capnhat",
				HUY_YEU_CAU: "hcCaseFlight.huyyeucau",
				PHE_DUYET: "hcCaseFlight.pheduyet",
				DANG_KY: "hcCaseFlight.dangky",
				TU_CHOI: "hcCaseFlight.tuchoi"
			},

			KHACH_SAN: {
				CAP_NHAT: "hcCaseHotel.capnhat",
				HUY_YEU_CAU: "hcCaseHotel.huyyeucau",
				PHE_DUYET: "hcCaseHotel.pheduyet",
				DANG_KY: "hcCaseHotel.dangky",
				TU_CHOI: "hcCaseHotel.tuchoi"
			},

			PHONG_HOP: {
				CAP_NHAT: "hcCasePhongHop.capnhat",
				HUY_YEU_CAU: "hcCasePhongHop.huyyeucau",
				PHE_DUYET: "hcCasePhongHop.pheduyet",
				DANG_KY: "hcCasePhongHop.dangky",
				TU_CHOI: "hcCasePhongHop.tuchoi"
			},

			SUA_CHUA_NHO: {
				CAP_NHAT: "hcSCN.capnhat",
				HUY_YEU_CAU: "hcSCN.huyyeucau",
				PHE_DUYET: "hcSCN.pheduyet",
				DANG_KY: "hcSCN.dangky",
				TU_CHOI: "hcSCN.tuchoi"
			}
		}
	},

	INTERMEDIATE_VIEW: {
		TYPE: {
			DOC_OUT_V2: "docOutV2",
			DOC_IN_V2: "docInV2",
			TASK: "task",
			HANH_CHINH: "hanhchinh",
			HC_CASE_CALENDAR_ATTACHMENT: "hcCaseCalendarAttachment",
			HC_COMMANDS: "hcCommands",
			HC_DIEU_XE: "hcCaseDieuXe",
			HC_CASE_FLIGHT: "hcCaseFlight",
			HC_CASE_HOTEL: "hcCaseHotel",
			TO_TRINH_QUA_HAN_REMIND: "toTrinhQuaHanRemind",
			HC_CASE_PHONGHOP: "hcCasePhongHop",
			HC_CASE_SCN: "hcCaseSCN"
		}
	},

	TOKEN_CA: {
		STATUS: {
			SUCCESS: 2,
			ERROR: 3
		}
	},

	OUTGOING_DOC: {
		IS_KY_NGOAI: {
			TRUE: 1
		}
	},

	ROOT_DEPT_CODE: "ROOT",
	HDTV_DEPT_CODE: "HDTV",
	TCT_DEPT_CODE: "TCT",
	TCT_DEPT_ID: "TCT",

	VB_BOOK_DOC_TYPE: {
		STATUS: {
			ACTIVE: 1,
			DEACTIVE: 0
		}
	},

	DELEGATE_INFO: {
		STATUS: {
			ACTIVE: 1,
			DEACTIVE: 0
		},
		EFFECTED: {
			TRUE: 1,
			FALSE: 0
		},
		TYPE: {
			DOC_PROCESS: "docProcess",
			TASK: "task"
		}
	},

	DU_THAO_PAGE: {
		FILTER: {
			ALL: "all",
			CHO_XU_LY: "choXuLy",
			DA_XU_LY: "daXuLy",
			UY_QUYEN: "uyQuyen",
			PHOI_HOP: "phoiHop",
			CC: "cc",
			DA_XOA: "daXoa"
		}
	},

	VBDEN_CHOXULY_PAGE: {
		FILTER: {
			ALL: "all",
			CHU_TRI: "chuTri",
			PHOI_HOP: "phoiHop",
			NHAN_DE_BIET: "nhanDeBiet"
		}
	},

	VB_DOC_USER: {
		RELATION_TYPE: {
			NGUOI_SOAN_THAO: "nguoiSoanThao",
			NGUOI_XU_LI: "nguoiChuyenXuLi",
			NGUOI_UY_QUYEN: "nguoiUyQuyen",
			NGUOI_PHOI_HOP: "nguoiPhoiHop",
			NGUOI_DUOC_CC: "nguoiDcCC",
			NGUOI_DUOC_BCC: "nguoiDcBCC"
		}
	},

	DETAIL_DOCS_PAGE: {
		A4_WIDTH_AT_72_PPI: 595,
		A4_WIDTH_AT_150_PPI: 1240,
		A4_WIDTH_AT_96_PPI: 794,
		TEXT_MARGIN: 1,

		TEXT_TYPE: {
			DOC_DATE: "docDate",
			DOC_CODE: "docCode",
			PUBLISHER_INFO: "publisherInfo",
			PHU_LUC: "phuLuc",
			CHI_DAO: "chiDao"
		},

		SHAPE_TYPE: {
			CON_DAU: "conDau",
			CHU_KY: "chuKy",
			DOC_DATE: "docDate",
			PHU_LUC: "phuLuc",
			DOC_CODE: "docCode",
			PUBLISHER_INFO: "publisherInfo",
			CHI_DAO: "chiDao"
		},
		MAX_LETTER_IN_ROW: 40,
		MAX_LETTER_CHI_DAO_IN_ROW: 80,

		ACTION: {
			ADD_TEXT: "addText",
			ADD_IMAGE: "addImage"
		},

		STYLE_DEFAULT: {
			FONT_SIZE: 18,
			DOC_CODE_WIDTH: 220,
			DOC_DATE_WIDTH: 220,
			PUBLISHER_INFO_WIDTH: 400,
			CHI_DAO_WIDTH: 550,
			DOC_DATE_FONT_SIZE: 17,
			PHU_LUC_FONT_SIZE: 17,
			PHU_LUC_WIDTH: 440,
			TEXT_WIDTH: 100,
			FONT_STYLE: "normal",
			FONT_FAMILY: "Times New Roman",
			PUBLISHER_INFO_FILL: "blue",
			CHI_DAO_FILL: "blue",
			STAMP_FIXED_WIDHT: 213,
			TEXT_PADDING: 3
		},
		ALIGN: {
			LEFT: "left",
			RIGHT: "right",
			CENTER: "center",
			JUSTIFY: "justify"
		},
		FONTSTYLE: {
			NORMAL: "normal",
			BOLD: "bold",
			ITALIC: "italic"
		},
		DRAW_LAYER_NAME: "drawLayer"
	},

	HTTP_STATUS: {
		FORBIDDEN: 403,
		UNAUTHORIZED: 401,
		BAD_REQUEST: 400
	},

	VB_BOOK: {
		STATUS: {
			ACTIVE: 1,
			DEACTIVE: 0
		}
	},

	REPORT: {
		DOCINBOOK: {
			TYPE: {
				INCOMINGDOC_BYDATERANGE: "incomingDocInBookByDateRange",
				INCOMINGDOC_BYNUMBERRANGE: "incomingDocInBookByNumberRange",
				OUTGOINGDOC_BYDATERANGE: "outgoingDocInBookByDateRange",
				OUTGOINGDOC_BYNUMBERRANGE: "outgoingDocInBookByNumberRange"
			},
			REPORT_URL: "report/vanBanTheoSoReport"
		},

		TIEPNHANVANBAN: {
			REPORT_URL: "report/tiepNhanVanBanReport"
		},

		VB_DOC: {
			TYPE: {
				INCOMING_DOC_CANHAN: "incomingDocCanhan",
				INCOMING_DOC_DONVI: "incomingDocDonVi",
				INCOMING_DOC_TINHHINHXLVB: "tinhHinhXlVb",
				OUTGOING_DOC_CANHAN: "outgoingDocCanhan",
				OUTGOING_DOC_DONVI: "outgoingDocDonVi"
			},
			REPORT_URL: "report/vanBanTheoTrangThaiReport",
			URL: {
				BAOCAOTINHHINHXLVB: "report/tinhHinhXuLyVanBan"
			}
		},

		QLCV: {
			TYPE: {
				BAOCAOTIENDOHOANTHANHCV: "baoCaoTienDoHoanThanhCv",
				BAOCAOTONGHOPTHANG: "baoCaoTongHopThang",
				RANKING_TONGHOP: "rankingTongHop",
				RANKING_TRUNGBINHTHANG: "rankingTrungBinhThang"
			},
			URL: {
				BAOCAOTONGHOPTHANG: "report/baoCaoTongHopThang",
				RANKING_BAOCAOTONGHOP: "rankingReport/export/baoCaoTongHopReport",
				RANKING_TRUNGBINHTHANGREPORT:
					"rankingReport/export/trungBinhThangReport"
			}
		},

		LICH_TUAN: {
			REPORT_URL: "report/lichTuanChuaDuyetReport"
		},

		HC_COMMANDS: {
			BAO_CAO_TONG_HOP_URL: "hcCaseCommandsReport/baoCaoTongHop",
			BAO_CAO_CHI_TIET_URL: "hcCaseCommandsReport/baoCaoChiTiet",

			BAO_CAO_TONG_HOP_TYPE: "hcCaseCommandsReport",
			BAO_CAO_CHI_TIET_TYPE: "hcCaseCommandsChiTietReport"
		},

		BAO_CAO_DIEU_XE_URL: "hcCaseDieuXeReport",

		MAY_BAY: {
			REPORT_URL: "hcCaseFlightReport",
			REPORT_TH_URL: "hcCaseFlightReport/baoCaoTongHop"
		}
	},

	HC_CFG_CAR: {
		USE_FOR_MANAGER: {
			TRUE: 1,
			FALSE: 0
		}
	},

	PROCESS_TREE: {
		NODE_TYPE: {
			//luong van ban di
			INCOMING_START: "incomingStart",
			CXL_DONVI_PROCESS_NODE: "cxlDonVi",
			CXL_CANHAN_PROCESS_NODE: "cxlCaNhan",
			CHUYENTIEP_NODE: "chuyenTiep",
			//luong van ban den
			EDITOR_NODE: "editorNode",
			BANHANH_NODE: "banHanhNode",
			CHOBANHANH_NODE: "choBanHanhNode",
			DONVIBANHANH_NODE: "donViBanHanhNode",
			DONVIBANHANHNGOAI_NODE: "donViBanHanhNgoaiNode",
			TUCHOITIEPNHAN_NODE: "tuChoiTiepNhanNode",
			TUCHOI_NODE: "tuChoiNode",
			TUCHOIBANHANH_NODE: "tuChoiBHanhNode",
			PROCESS_NODE: "vbOutgoingProcessNode",
			HDTV_NODE: "hdtvNode",
			EDITOR_DEPT_NODE: "editorDeptNode",
			SIGNER_NODE: "signerNode",
			PUBLISHER_DEPT_NODE: "publisherDeptNode"
		}
	},

	GROUPS: {
		GROUP_TYPE_ID: {
			CA_NHAN: 0,
			DON_VI: 1
		}
	},

	TRUE: 1,
	FALSE: 0,

	SHARE_LIBRARY: {
		STATUS: {
			ACTIVE: "active",
			DEACTIVE: "deactive"
		}
	},

	DEFAULT_DATETIME_FORMAT: "DD/MM/YYYY HH:mm",
	DEFAULT_DATE_FORMAT: "DD/MM/YYYY",

	CATEGORY_CODE: {
		TO_TRINH_XIN_Y_KIEN_HDTV: "ttrhdtv",
		GIAI_TRINH_Y_KIEN_HDTV: "gtrhdtv",
		PHIEU_Y_KIEN: "phieuykien"
	},

	STEERING_TYPE: {
		KHONGPHAICHIDAO: 0,
		CHIDAO: 1,
		BAOCAOCHIDAO: 2
	},
	CREATE_DOCIN_PAGE: {
		MODE: {
			FOR_SAVE: "forSave",
			FOR_FORWARD_NEXT_HANDLER: "forForwardNextHandler"
		}
	},

	LICH_TUAN_PAGE: {
		FILTER: {
			ALL: "all",
			CHUA_PHE_DUYET: "Chưa phê duyệt",
			TAM_PHE_DUYET: "Tạm phê duyệt",
			DA_BAN_HANH: "Đã ban hành",
			HUY_YEU_CAU: "Hủy yêu cầu",
			KHONG_PHE_DUYET: "Không phê duyệt"
		}
	},

	HC_CALENDAR: {
		APPROVE_STATUS: {
			DA_DANG_KY: "Đã đăng ký",
			CHUA_PHE_DUYET: "Chưa phê duyệt",
			TAM_PHE_DUYET: "Tạm phê duyệt",
			DA_BAN_HANH: "Đã ban hành",
			HUY_YEU_CAU: "Hủy yêu cầu",
			KHONG_PHE_DUYET: "Không phê duyệt"
		}
	},

	VB_OUTGOING_DOC_RECEIVERS: {
		RECEIVE_STATUS: {
			CHO_PHAN_HOI: "choPhanHoi",
			DA_DEN: "daNhan",
			TU_CHOI_TIEP_NHAN: "tuChoiTiepNhan",
			TIEP_NHAN: "tiepNhan",
			PHAN_CONG: "phanCong",
			DANG_XU_LY: "dangXuLy",
			HOAN_THANH: "hoanThanh"
		}
	},

	TK_TASK_VIEW: {
		DELEGATE_FILTER: {
			DIRECT: "direct", //giao viec truc tiep
			DELEGATE: "delegate", //giao viec uy quyen;
			ALL: "all" //all;
		}
	},

	ACTOR_GROUPS: {
		HDTV: "hoidongthanhvien",
		BANTGD: "bantonggiamdoc",
		TVHDQT: "tvhdqt",
		KTT: "keToanTruong",
		BKS: "banKiemSoat",
	},

	HC_CASE_CALENDAR: {
		MEETING_TYPE: {
			ONLINE: "online",
			OFFLINE: "offline",
			ONLINE_MOBIMEETING_CODINH: "mobimeetingCoDinh",
			ONLINE_OTHER: "onlineOther"
		}
	},

	TIENDOHOANTHANHCV_REPORT: {
		TYPE: {
			TRUOC_HAN: "truocHan",
			DUNG_HAN: "dungHan",
			QUA_HAN: "quaHan"
		}
	},

	RANKING_REASON: {
		TYPE: {
			CONGDIEM: "congDiem",
			TRUDIEM: "truDiem"
		},

		SCORE_TYPE: {
			CHUYENMON: "chuyenMon",
			NGUYENTAC: "nguyenTac"
		}
	},

	STATUS_: {
		ACTIVE: "active",
		DEACTIVE: "deactive"
	},

	HC_CFG_MEETING_ROOM: {
		TYPE: {
			ONLINE_MOBIMEETING_CODINH: "mobimeetingCoDinh",
			NORMAL: "normal"
		}
	},

	CASE_MASTER_STATUS: {
		DANG_XU_LY: "DANGXULY",
		HOAN_THANH: "HOANTHANH",
		HUY: "HUY"
	},

	HC_CASE_COMMANDS: {
		PROGRESS: {
			ON_TIME: "ON_TIME",
			LATE: "LATE"
		},

		STATUS: {
			DANGXULY: "DANGXULY",
			HOANTHANH: "HOANTHANH",
			USUALLY: "USUALLY"
		},

		STATE: {
			CHO_BAO_CAO: "Chờ báo cáo",
			CHO_PHE_DUYET: "Chờ phê duyệt",
			DA_PHE_DUYET: "Đã phê duyệt",
			HUY_YEU_CAU: "Hủy yêu cầu"
		},

		SECTOR: {
			KINHDOANH: "Kinh Doanh",
			KITHUATDAUTU: "Kĩ thuật đầu tư",
			QUANLYCHUNG: "Quản lý chung",
			CNTT: "congNgheThongTin",
			DAU_TU: "dauTu",
			KHAC: "khac"
		},

		PROCESS_TYPE: {
			CHU_TRI: "chuTri",
			PHOI_HOP: "phoiHop"
		},

		COMMAND_STATUS: {
			COMPLETE: "COMPLETE",
			PROCESSING: "PROCESSING",
			USUALLY: "USUALLY"
		},

		PROGRESS_STATUS: {
			CHAM: "cham",
			DUNG_TIEN_DO: "dungTienDo"
		}
	},

	HC_CASE_COMMANDS_USER: {
		TYPE: {
			PHU_TRACH_CAP1: "phuTrachCap1",
			PHU_TRACH_CAP2: "phuTrachCap2"
		}
	},

	HC_STATE: {
		STATE_CODE: {
			INIT_STATE: "init_state",

			CHI_DAO: {
				DANG_THUC_HIEN: "dangThucHien_state",
				CHO_PHE_DUYET_HOAN_THANH: "choPheDuyetHoanThanh_state",
				HOAN_THANH: "hoanThanh_state",
				HUY_CHI_DAO: "huyChiDao_state"
			},

			DIEU_XE: {
				CHO_PHE_DUYET: "chopheduyet_state",
				DA_PHE_DUYET: "dapheduyet_state",
				TU_CHOI: "khongpheduyet_state",
				HUY: "huyyeucau_state",
				DA_DANG_KY: "dadangky_state",
			},

			MAY_BAY: {
				HUY: "huyyeucau_state",
				DA_PHE_DUYET: "dapheduyet_state",
				TU_CHOI: "khongpheduyet_state",
				CHO_PHE_DUYET: "chopheduyet_state",
				DA_DANG_KY: "dadangky_state",
			}
		},

		STATE_TYPE: {
			BAT_DAU: "BATDAU"
		}
	},

	HC_STATE_TO_STATE: {
		STATE_TO_STATE_TYPE: {
			BAT_DAU: "BATDAU"
		},
		ACTION_CODE: {
			CHI_DAO: {
				TAO_KET_LUAN: "taoKetLuan",
				BAO_CAO_TIEN_DO: "baoCaoTienDo",
				BAO_CAO_HOAN_THANH: "baoCaoHoanThanh",
				YEU_CAU_BO_SUNG: "yeuCauBoSung",
				PHE_DUYET: "pheDuyetHoanThanh",
				HUY: "huy"
			},

			DIEU_XE: {
				CAP_NHAT: "capnhat",
				HUY_YEU_CAU: "huyyeucau",
				PHE_DUYET: "pheduyet",
				DANG_KY: "dangky",
				TU_CHOI: "tuchoi"
			},

			MAY_BAY: {
				HUY: "huyyeucau",
				CAP_NHAT: "capnhat",
				TU_HUY: "tuhuyyeucau",
				DANG_KY: "dangky",
				PHE_DUYET: "pheduyet",
				TU_CHOI: "tuchoi"
			},

			PHONG_HOP: {
				HUY: "huyyeucau",
				CAP_NHAT: "capnhat",
				DANG_KY: "dangky",
				PHE_DUYET: "pheduyet",
				TU_CHOI: "tuchoi"
			}
		}
	},

	HC_DOC_RELATION: {
		REFERENCE_OBJECT_TYPE: {
			VB_OUTGOING_DOC: "vbOutgoingDoc",
			VB_ATTACHMENT: "vbAttachment"
		},

		OBJECT_TYPE: {
			HC_CASE_COMMANDS: "hcCaseCommands",
			HC_CASE_COMMANDS_COMMON: "hcCaseCommandsCommon"
		}
	},

	HC_CASE_DIEUXE: {
		REQUEST_TYPE: {
			NOITHANH: "NOITHANH",
			LIENTINH: "LIENTINH"
		}
	},

	HC_CASE_FLIGHT_USER: {
		GENDER: {
			MALE: "M",
			FEMALE: "F"
		}
	},

	HC_CASE_FLIGHT_FILE: {
		TYPE: {
			TO_TRINH: 1,
			VE_MAY_BAY: 2,
			KHACH_SAN: {
				TO_TRINH: 3,
				VE_KHACH_SAN: 4
			}
		}
	},

	HC_MASTER_CASE_REQUEST_VIEW: {
		FILTER_FORM_STATUS: {
			DA_XU_LY: "processed",
			CHO_XU_LY: "processing"
		}
	},

	HC_FLOW: {
		FLOW_CODE: {
			CHI_DAO: "CHI_DAO",
			DIEU_XE: "DIEU_XE",
			MAY_BAY: "VEMAYBAY",
			KHACH_SAN: "KHACH_SAN",
			PHONG_HOP: "PHONG_HOP",
			SUA_CHUA_NHO: "SUA_CHUA_NHO"
		}
	},

	HC_CASE_HOTEL_PRICE: {
		ROOM_TYPE: {
			PHONG_DON: 1,
			PHONG_DOI: 2
		}
	},

	TO_TRINH_QUA_HAN: {
		STATE: {
			ALL: "all",
			CHUA_XU_LY: "chuaXuLy",
			DA_BINH_LUAN: "daBinhLuan",
			DA_XU_LY: "daXuLy"
		}
	},

	HISTORY: {
		TYPE: {
			ACTION_LOG: "actionLog",
			COMMENT: "comment"
		}
	},

	HC_CASE_PHONGHOP: {
		CRITICAL_LEVEL: {
			QUAN_TRONG: "QUANTRONG",
			CO_LANH_DAO: "COLANHDAO",
			KHONG_LANH_DAO: "KHONGLANHDAO"
		},

		SERVICES: {
			NUOC: "NUOC",
			HOA_QUA: "HOAQUA",
			MAY_CHIEU: "MAYCHIEU",
			TRUYEN_HINH: "TRUYENHINH"
		}
	},

	CAU_HINH_LUONG_PAGE: {
		POINT: {
			TYPE: {
				START: "start",
				END: "end"
			}
		},

		ACTION: {
			ADD_NODE: "addNode",
			ADD_LINE: "addLine",
			VIEW_NODE: "viewNode"
		}
	}
};



// WEBPACK FOOTER //
// ./src/constants.js